import {
  FooterLinkDto,
  FooterLinkDtoProfileEnum,
  FooterLinkRequestDto,
  FooterLinkRequestDtoProfileEnum,
} from 'lib_api/lib/api/gen';

import { profileEnumMapping } from 'utils/enumData';
import { ShouldNotHappen } from 'utils/exceptions';

import { FooterLinkFormValue } from '../types';

export function buildDto(values: FooterLinkFormValue): FooterLinkRequestDto {
  return {
    link: values.link ?? '',
    text: values.text ?? null,
    profile: values.profile ?? null,
  };
}

export function buildDefaultUpdateFormValues(
  footerLink: FooterLinkDto,
): FooterLinkFormValue {
  return {
    link: footerLink.link,
    text: footerLink.text ?? undefined,
    profile: mapFooterLinkProfileEnum(footerLink.profile),
  };
}

function mapFooterLinkProfileEnum(
  profile: FooterLinkDtoProfileEnum | null,
): FooterLinkRequestDtoProfileEnum | undefined {
  if (profile === null) {
    return undefined;
  }
  switch (profile) {
    case FooterLinkDtoProfileEnum.ADMIN_FONCTIONNEL:
      return FooterLinkRequestDtoProfileEnum.ADMIN_FONCTIONNEL;
    case FooterLinkDtoProfileEnum.AUTORITE_FOURRIERE:
      return FooterLinkRequestDtoProfileEnum.AUTORITE_FOURRIERE;
    case FooterLinkDtoProfileEnum.GARDIEN_FOURRIERE:
      return FooterLinkRequestDtoProfileEnum.GARDIEN_FOURRIERE;
    case FooterLinkDtoProfileEnum.FORCE_DE_L_ORDRE:
      return FooterLinkRequestDtoProfileEnum.FORCE_DE_L_ORDRE;
    case FooterLinkDtoProfileEnum.CSU:
      return FooterLinkRequestDtoProfileEnum.CSU;
    case FooterLinkDtoProfileEnum.DSR_BLR:
      return FooterLinkRequestDtoProfileEnum.DSR_BLR;
    case FooterLinkDtoProfileEnum.TRIBUNAL_JUDICIAIRE:
      return FooterLinkRequestDtoProfileEnum.TRIBUNAL_JUDICIAIRE;
    case FooterLinkDtoProfileEnum.COUR_APPEL:
      return FooterLinkRequestDtoProfileEnum.COUR_APPEL;
    case FooterLinkDtoProfileEnum.UNITE_OPERATIONNELLE:
      return FooterLinkRequestDtoProfileEnum.UNITE_OPERATIONNELLE;
    case FooterLinkDtoProfileEnum.NATIONAL_JUSTICE:
      return FooterLinkRequestDtoProfileEnum.NATIONAL_JUSTICE;
    default:
      throw new ShouldNotHappen(profile);
  }
}

export function mapToReadableProfile(
  profile: FooterLinkDtoProfileEnum | null,
): string | null {
  if (profile == null) {
    return null;
  }
  return profileEnumMapping[profile].name;
}
